module.exports = __webpack_public_path__ + "media/images/icons/spotify_footer-06f352120ac1d1dd7e66f4f19ace08a8.svg";